import * as React from "react"
import { styled } from "../stitches.config";
import Box from "./Box";

const Section = styled(Box, {
    mb: "$4",
})

export default Section